import { isRTL } from "src/utils/global";
import { ToastOptions } from "react-toastify";

export const toastOptions: ToastOptions = {
    rtl: isRTL(),
    style: { width: "fit-content", fontFamily: "Alexandria" },
    position: isRTL() ? "bottom-right" : "bottom-left",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
};